/**
 * Returns true for internal Simply Invent Labs email addresses
 * and the specific allowlisted account.
 */
export function isInternalUser(email?: string): boolean {
  if (!email) return false;
  const lower = email.toLowerCase();
  if (lower === 'janeevjoy@gmail.com') return true;
  if (lower === 'gsmtestuser@marketplacetest.net') return true;
  if (lower.startsWith('janeevjoy+') && lower.endsWith('@gmail.com')) return true;
  if (lower.startsWith('support') && lower.endsWith('@simplyinventlabs.com')) return true;
  
  return false;
}
